import '../css/LandingPage.css';
import '../root.css';
import { useState, useEffect } from 'react';
import SEO from '../components/SEO';
import HeroSection from '../components/sections/HeroSection';
import TechStackMarquee from '../components/sections/TechStackMarquee';
import ProjectsSection from '../components/sections/ProjectsSection';
import AchievementsSection from '../components/sections/AchievementsSection';
import LinkedInSection from '../components/sections/LinkedInSection'
import Quote from '../components/sections/Quote';
import ContactSection from '../components/sections/ContactSection';

function LandingPage() {
    const [darkLogo, setDarkLogo] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + 100;

            const heroSection = document.querySelector('.hero-container');
            const marqueeSection = document.querySelector('.marquee-container');
            // const aboutSection = document.querySelector('.about-container');
            const projectsSection = document.querySelector('.projects-container');
            const achievementsSection = document.querySelector('.achievements-container');
            const linkedInSection = document.querySelector('.linkedin-container');
            const quoteSection = document.querySelector('.quote-container');

            const heroBottom = heroSection?.offsetTop + heroSection?.offsetHeight || 0;
            const marqueeBottom = marqueeSection?.offsetTop + marqueeSection?.offsetHeight || 0;
            // const aboutBottom = aboutSection?.offsetTop + aboutSection?.offsetHeight || 0;
            const projectsBottom = projectsSection?.offsetTop + projectsSection?.offsetHeight || 0;
            const achievementsBottom = achievementsSection?.offsetTop + achievementsSection?.offsetHeight || 0;
            const linkedInBottom = linkedInSection?.offsetTop + linkedInSection?.offsetHeight || 0;
            const quoteBottom = quoteSection?.offsetTop + quoteSection?.offsetHeight || 0;

            if ((scrollPosition > heroBottom && scrollPosition <= marqueeBottom) ||
                (scrollPosition > projectsBottom && scrollPosition <= quoteBottom) ||
                (scrollPosition > achievementsBottom && scrollPosition <= linkedInBottom)) {
                setDarkLogo(true);
            } else {
                setDarkLogo(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <SEO />
            <HeroSection darkLogo={darkLogo} />
            <TechStackMarquee />
            <ProjectsSection />
            <Quote darkLogo={darkLogo} />
            <AchievementsSection />
            <LinkedInSection darkLogo={darkLogo} />
            <ContactSection />
        </>
    )
}

export default LandingPage;
